

<div class="lightBox createpage block">
    <div class="headerLight">
      <div (click)="resetForm()" class="close fl spImg"></div>
    </div>
    <div class="lightContent">
      <div class="addUser">
        <h3>Create {{pageType=='SUBSECTION_L2'?'Sub Sub Section': 
          pageType=='APP_SECTION'?'App Section': pageType=='APP_SUBSECTION'?'App Sub Section':pageType}} page</h3>
        <p></p>
        <!-- <ng-container *ngIf="pageType == 'SUBSECTION' || pageType == 'TOPIC';then showSection else disableSection"> </ng-container> -->
        <ng-container *ngIf="pageType == 'SUBSECTION' || pageType == 'TOPIC'">
          <div class="authorName metatitle fl100">
              <div>
                <label>Name</label>
              </div>
              <div class="Input">
                <input type="text" [id]="pageType == 'SUBSECTION' ? 'pageSectionNameText' : 'pageTopicNameText'" id=""  class="textBox" [disabled]="!adminRole" [formControl]='searchQuery'
                placeholder="Add  name." [(ngModel)]="formData.name" >
              <!--   <span class="tickcls redname" *ngIf="alreadyUsed" ><i class="icon-close"></i></span> -->
              </div>
            <!--   <span class="nameused" *ngIf="alreadyUsed">Already Used</span> -->
          </div>
          <div class="authorName fl100">
            <div class="">
              <label>Alias</label>
            </div>
            <div class="Input">
              <input type="text" [id]="pageType == 'SUBSECTION' ? 'pageSectionAliasText' : 'pageTopicAliasText'" class="textBox" [disabled]="!adminRole" [formControl]='searchQuery'
              placeholder="Enter Alias here" [(ngModel)]="formData.alias">
            <!--   <span *ngIf="name.error">Please Enter only English Alphbets</span> -->
              <span class="tickcls redalias" *ngIf="alreadyUsed" ><i class="icon-close"></i></span>

            </div>
            <span class="aliasused" *ngIf="alreadyUsed">Already Used</span>
            <span class="hindiChar" *ngIf="invalidData && !alreadyUsed">Please Enter English Charaecters Only</span>
        </div>

        <div class="authorName fl100" *ngIf="domainConfig['config']['pages'] && domainConfig['config']['pages']['topicStockUrl']">
          <div class="">
            <label>Stock</label>
          </div>
          <div class="Input" >
            <input type="text" id="stockBox" class="textBox" (keydown)="onKeydown($event)" [class]="formData.title ? 'textBox' : 'textBox errorInput'" [disabled]="!formData.alias"
            #stockInput placeholder="Select Stock here." [(ngModel)]="stockQuery" (keyup)="filterAutoComplete('stock')">

            <div class="autosuggestion block" *ngIf="filteredMarketUrlSuggestions && filteredMarketUrlSuggestions.length > 0 && formData.alias">
              <ul>
                  <ng-container *ngFor="let item of filteredMarketUrlSuggestions;let i = index">
                <li [class.active]="i == arrowkeyLocation" (click)="selectMarketStock(item)">
                  <span class="name">{{item.name}}</span>
                </li>
              </ng-container>
              </ul>
            </div>
          </div>
        </div>

          <div class="authorName fl100">
            <div class="">
              <label>Section</label>
            </div>
            <div class="Input" >
            <input type="text" id="sectionBox" class="textBox" (keydown)="onKeydown($event)" [class]="formData.title ? 'textBox' : 'textBox errorInput'" [disabled]="!formData.alias"
            #sectionInput placeholder="Select Section here." [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteSection('section')">

            <div class="autosuggestion block" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0 && formData.alias">
              <ul>
                  <ng-container *ngFor="let item of filteredSectionSuggestion;let i = index">
                <li [class.active]="i == arrowkeyLocation" (click)="selectAutoComplete(item,pageType)">
                  <span class="name">{{item.value}}</span>
                </li>
              </ng-container>
              </ul>
          </div>

        </div>
          </div>
        </ng-container>

        <ng-container *ngIf="pageType == 'APP_SUBSECTION'">
            <div class="authorName metatitle fl100">
                <div>
                  <label>Name</label>
                </div>
                <div class="Input">
                  <input type="text" [id]="pageSectionNameText" id=""  class="textBox" [disabled]="!adminRole" [formControl]='searchQuery'
                  placeholder="Add  name." [(ngModel)]="formData.name" >
                </div>
            </div>
            <div class="authorName fl100">
              <div class="">
                <label>Alias</label>
              </div>
              <div class="Input" style="display: flex;">
                <span class="prefix">app </span> 
                <input style="padding-left: 35px;" type="text" [id]="pageSectionAliasText" class="textBox" [disabled]="!adminRole" [formControl]='searchQuery'
                placeholder="Enter Alias here" [(ngModel)]="formData.alias">
              <!--   <span *ngIf="name.error">Please Enter only English Alphbets</span> -->
                <span class="tickcls redalias" *ngIf="alreadyUsed" ><i class="icon-close"></i></span>

              </div>
              <span class="aliasused" *ngIf="alreadyUsed">Already Used</span>
              <span class="hindiChar" *ngIf="invalidData && !alreadyUsed">Please Enter English Charaecters Only</span>
          </div>

          <!-- Only for app subsection -->
            <div class="authorName fl100">
              <div class="">
                <label>App Section</label>
              </div>
              <div class="Input">
                <input type="text" id="appSectionBox" class="textBox" (keydown)="onKeydown($event)"
                  [class]="formData.title ? 'textBox' : 'textBox errorInput'" [disabled]="!formData.alias" #appSectionInput
                  placeholder="Select App Section here." [(ngModel)]="appSectionQuery" (keyup)="filterAutoComplete('appSection')">
          
                <div class="autosuggestion block"
                  *ngIf="filteredAppSectionSuggestion && filteredAppSectionSuggestion.length > 0 && formData.alias">
                  <ul>
                    <ng-container *ngFor="let item of filteredAppSectionSuggestion;let i = index">
                      <li [class.active]="i == arrowkeyLocation" (click)="selectAutoComplete(item,pageType)">
                        <span class="name">{{item.value}}</span>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </div>
          </ng-container>
        <ng-container *ngIf="pageType == 'SUBSECTION_L2'">
            <div class="authorName metatitle fl100">
                <div>
                  <label>Name</label>
                </div>
                <div class="Input">
                  <input type="text" [id]="pageType == 'SUBSECTION_L2' ? 'pageSectionNameText' : 'pageTopicNameText'" id=""  class="textBox" [disabled]="!adminRole" [formControl]='searchQuery'
                  placeholder="Add  name." [(ngModel)]="formData.name" >
                <!--   <span class="tickcls redname" *ngIf="alreadyUsed" ><i class="icon-close"></i></span> -->
                </div>
              <!--   <span class="nameused" *ngIf="alreadyUsed">Already Used</span> -->
            </div>
            <div class="authorName fl100">
              <div class="">
                <label>Alias</label>
              </div>
              <div class="Input">
                <input type="text" [id]="pageType == 'SUBSECTION_L2' ? 'pageSectionAliasText' : 'pageTopicAliasText'" class="textBox" [disabled]="!adminRole" [formControl]='searchQuery'
                placeholder="Enter Alias here" [(ngModel)]="formData.alias">
              <!--   <span *ngIf="name.error">Please Enter only English Alphbets</span> -->
                <span class="tickcls redalias" *ngIf="alreadyUsed" ><i class="icon-close"></i></span>

              </div>
              <span class="aliasused" *ngIf="alreadyUsed">Already Used</span>
              <span class="hindiChar" *ngIf="invalidData && !alreadyUsed">Please Enter English Charaecters Only</span>
          </div>

        

            <div class="authorName fl100">
              <div class="">
                <label>Section</label>
              </div>
              <div class="Input" >
              <input type="text" id="sectionBox" class="textBox" (keydown)="onKeydown($event)" [class]="formData.title ? 'textBox' : 'textBox errorInput'" [disabled]="!formData.alias"
              #sectionInput placeholder="Select Section here." [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteSection('section')">

              <div class="autosuggestion block" *ngIf="filteredSectionSuggestion && filteredSectionSuggestion.length > 0 && formData.alias">
                <ul>
                    <ng-container *ngFor="let item of filteredSectionSuggestion;let i = index">
                  <li [class.active]="i == arrowkeyLocation" (click)="selectAutoComplete(item,pageType)">
                    <span class="name">{{item.value}}</span>
                  </li>
                </ng-container>
                </ul>
            </div>

          </div>
            </div>
            <div class="authorName fl100">
              <div class="">
                <label>SubSection</label>
            </div>
            <div class="Input">
              <input type="text"  class="textBox" #subsectionInput
              placeholder="Add name." [(ngModel)]="subsectionQuery"
              (keyup)="filterAutoComplete('subsection')" [disabled]="!formData.alias">
            <div class="autosuggestion block" *ngIf="insideSubSection && filteredSubSectionSuggestion && filteredSubSectionSuggestion.length > 0">
                <ul>
                    <ng-container *ngFor="let item of filteredSubSectionSuggestion;let i = index">
                  <li [class.active]="i == arrowkeyLocation" (click)="selectAutoCompleteSubsectionL2(item,pageType)">
                    <span class="name">{{item.value}}</span>
                  </li>
                </ng-container>
                </ul>
            </div>
          </div>
          <ng-container *ngIf="(filteredSubSectionSuggestion && filteredSubSectionSuggestion.length < 0)">
              <div class="autosuggestion block">
                <ul>
                  <li>
                    <span class="name">No Results</span>
                  </li>
                </ul>
              </div>
            </ng-container>
            </div>
          </ng-container>
          <div class="authorName fl100"  *ngIf=" pageType === 'BRUNCH'">
            <div class="">
              <label>Edition Date</label>
            </div>
            <div class="Input">
              <input type="date" class="textBox" [(ngModel)]="formData.editionDate"
               placeholder="Add Edition Date" (change)="validateEditionDate()">
            </div>
          </div>

          <ng-container *ngIf="pageType == 'SECTION'|| pageType === 'SERIES'||pageType === 'BRUNCH' || pageType == 'PRIMARY' || pageType == 'COMPANY' || pageType == 'APP_SECTION' ">
              <div class="authorName fl100">
                  <div class=""><label>Name</label></div>
                  <div class="Input">
                    <input [disabled]="pageType === 'BRUNCH'" type="text" [id]="pageType == 'PRIMARY' ? 'pagePrimaryNameText' : 'pageSectionNameText'" class="textBox" [disabled]="!adminRole"
                    placeholder="Add  name." [(ngModel)]="formData.name" [readonly]="!adminRole" >
                   <!--  <span class="tickcls redname" *ngIf="alreadyUsed" ><i class="icon-close"></i></span> -->
                  </div>
                 <!--  <span class="nameused" *ngIf="alreadyUsed">Already Used</span> -->
                </div>
              
          </ng-container>
          <div class="authorName fl100"  *ngIf="pageType == 'SERIES'">
            <div class="">
              <label>Short Name</label>
            </div>
            <div class="Input">
              <input type="text" class="textBox" [(ngModel)]="formData.shortName"
               placeholder="Add Short Name">
            </div>
          </div>
          <div class="authorName fl100"  *ngIf="pageType == 'SERIES'">
            <div class="">
              <label>Display Name</label>
            </div>
            <div class="Input">
              <input type="text" class="textBox" [(ngModel)]="formData.displayName"
               placeholder="Add Display Name">
            </div>
          </div>
        <ng-container *ngIf="pageType == 'AGENCY'">
          <div class="authorName fl100">
              <div class=""><label>Agency</label></div>
              <div class="Input">
                <!-- <input type="text"  class="textBox" [disabled]="!adminRole"
                placeholder="Add  name." [(ngModel)]="formData.name" [readonly]="!adminRole" > -->
                <input type="text" class="textBox" #agencyInput [readonly]="!adminRole" placeholder="Add Agency Name"
                [(ngModel)]="agencyQuery" (keyup)="filterAutoCompleteUp($event ,'agency')" (keydown)="filterAutoCompleteDown($event ,'agency')"
                (focus)="focusInSuggest('agency')" (focusout)="false">
              <ng-container *ngIf="adminRole">
                <div #agencyList class="autosuggestion block" *ngIf="filteredAgencySuggestion && filteredAgencySuggestion.length > 0">
                  <ul *ngFor="let item of filteredAgencySuggestion; let i = index">
                    <li (click)="selectAutoCompleteMeta('agency', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item}}</span>
                      <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="insideAgency && (1 > filteredAgencySuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
              </div>
            </div>
      </ng-container>
      <div class="authorName fl100" *ngIf="pageType == 'SECTION' || pageType == 'PRIMARY'|| pageType === 'SERIES' || pageType == 'AGENCY' || pageType == 'COMPANY'">
        <div class="">
          <label>Alias</label>
        </div>
        <div class="Input">
          <input type="text" [id]="pageType == 'PRIMARY' ? 'pagePrimaryAliasText' : (pageType == 'SECTION') ? 'pageSectionAliasText' : 'pageAgencyAliasText'"   class="textBox" [disabled]="!adminRole" [formControl]='searchQuery'
          placeholder="Enter Alias here" [(ngModel)]="formData.alias">
        <!--   <span *ngIf="name.error">Please Enter only English Alphbets</span> -->
          <span class="tickcls redalias" *ngIf="alreadyUsed" ><i class="icon-close"></i></span>

        </div>
        <span class="aliasused" *ngIf="alreadyUsed">Already Used</span>
        <span class="hindiChar" *ngIf="invalidData && !alreadyUsed">Please Enter English Charaecters Only</span>
    </div>

    <div class="authorName fl100" *ngIf="pageType === 'BRUNCH'">
      <div class="">
        <label>Alias</label>
      </div>
      <div class="Input">
        <input type="text" disabled class="textBox" [formControl]='searchQuery'
        placeholder="Enter Alias here" [(ngModel)]="formData.alias">
        <span class="tickcls redalias" *ngIf="alreadyUsed" ><i class="icon-close"></i></span>

      </div>
      <span class="aliasused" *ngIf="alreadyUsed">Already Used</span>
      <span class="hindiChar" *ngIf="invalidData && !alreadyUsed">Please Enter English Charaecters Only</span>
  </div>

    <div class="authorName fl100" *ngIf="pageType == 'APP_SECTION'">
        <div class="">
          <label>Alias</label>
        </div>
        <div class="Input" style="display: flex;">
          <span class="prefix">app </span> 
          <input style="padding-left: 35px;" type="text" [id]="pageSectionAliasText"   class="textBox" [disabled]="!adminRole" [formControl]='searchQuery'
          placeholder="Enter Alias here" [(ngModel)]="formData.alias">
        <!--   <span *ngIf="name.error">Please Enter only English Alphbets</span> -->
          <span class="tickcls redalias" *ngIf="alreadyUsed" ><i class="icon-close"></i></span>

        </div>
        <span class="aliasused" *ngIf="alreadyUsed">Already Used</span>
        <span class="hindiChar" *ngIf="invalidData && !alreadyUsed">Please Enter English Charaecters Only</span>
    </div>
        <div class="authorName fl100" *ngIf=" pageType !== 'BRUNCH'&&pageType !== 'SERIES'">
            <div class="">
              <label>Design</label>
            </div>
            <div class="Input" >
                <input type="text" class="textBox" [disabled]="pagePresent" readonly
                #designInput placeholder="Select Design here." [(ngModel)]="pageQuery" (click)="filterAutoComplete('design')">

                <div class="autosuggestion block" *ngIf="filteredpageDesign && filteredpageDesign.length > 0">
                  <ul *ngFor="let item of filteredpageDesign" >
                    <li (click)="selectAutoCompletePage(item)">
                      <span class="name">{{item.value}}</span>
                    </li>
                  </ul>
              </div>
              <ng-container *ngIf="(filteredpageDesign && filteredpageDesign.length < 0)">
                <div class="autosuggestion block">
                  <ul>
                    <li>
                      <span class="name">No Results</span>
                    </li>
                  </ul>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="authorName fl100" *ngIf="page.design === 'template'">
            <div class="">
              <label>Template Design</label>
            </div>
            <div class="Input" >
                <select [(ngModel)]="templateType">
                  <option *ngFor="let c of templateTypes" [ngValue]="c">{{c.name}}</option>
                </select>
            </div>
          </div>
        <div class="authorName fl100"  *ngIf="pageType !== 'BRUNCH' && pageType !== 'SERIES'">
          <div class="">
            <label>Title</label>
          </div>
          <div class="Input">
            <input type="text" [(ngModel)]="formData.title" [disabled]="pagePresent"
            class="textBox" placeholder="Add page’s meta title here">
          </div>
        </div>
        <div class="authorName fl100"  *ngIf="pageType !== 'BRUNCH' && pageType !== 'SERIES'">
          <div class="">
            <label>Keywords</label>
          </div>
          <div class="Input">
              <tags-creator class="textBox"  [editable]="pagePresent" [broadInput]="true" [data]="formData.keywords" [displayText]="'Add keywords here'" (changefn)="formData.keywords = $event"></tags-creator>
          </div>
        </div>
        <div class="authorName fl100" *ngIf="pageType === 'TOPIC'">
          <div class="">
            <label>Synonyms</label>
          </div>
          <div class="Input">
              <tags-creator class="textBox"  [editable]="pagePresent" [broadInput]="true" [data]="formData.synonyms" [displayText]="'Add synonyms here'" (changefn)="formData.synonyms = $event"></tags-creator>
          </div>
        </div>
         <div class="authorName fl100"  *ngIf=" pageType !== 'BRUNCH' && pageType !== 'SERIES'">
          <div class="">
            <label>Description</label>
          </div>
          <div class="Input">
            <input type="text" class="textBox" [(ngModel)]="formData.description"
            [disabled]="pagePresent" placeholder="Add meta description">
          </div>
        </div>
        <ng-container *ngIf="pageType != 'PRIMARY'">
        <div class="authorName fl100">
            <div class="">
              <label>URL</label>
            </div>
            <div class="Input">
              <input type="text" [(ngModel)]="formData.url" disabled
              class="textBox" placeholder="Add url">
              <span class="tickcls" *ngIf="!alreadyUsed"><i class="icon-checkbox-tick"></i></span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="pageType === 'PRIMARY'">
          <div class="authorName fl100">
              <div class="">
                <label>URL</label>
              </div>
              <div class="Input">
                <input type="text" [(ngModel)]="formData.url" [readonly]="!isUrlEditable" [formControl]='urlValidation'
                class="textBox" placeholder="Add url">
                <span class="tickcls" *ngIf="!alreadyUsed"><i class="icon-checkbox-tick"></i></span>
                <span class="tickcls redalias" *ngIf="alreadyUsed" ><i class="icon-close"></i></span>
              </div>
              <span class="aliasused" *ngIf="alreadyUsed">Already Used</span>
            </div>
          </ng-container>
          <div class="authorName fl100" *ngIf="pageType === 'SERIES'">
            <div class="">
              <label>Parent Series Page</label>
            </div>
            <div class="Input" >
              <input type="text" id="stockBox" class="textBox" (keydown)="onKeydown($event)" [class]="formData.title ? 'textBox' : 'textBox errorInput'"
              #parentSeriesPage placeholder="Select Parent Series Page here." [(ngModel)]="parentSeriesPageQuery" (keyup)="filterAutoComplete('parentSeriesPage')">
  
              <div class="autosuggestion block" *ngIf="filteredParentSeriesPage && filteredParentSeriesPage.length > 0">
                <ul>
                    <ng-container *ngFor="let item of filteredParentSeriesPage;let i = index">
                  <li [class.active]="i == arrowkeyLocation" (click)="selectParentSeriesPage(item)">
                    <span class="name">{{item.name}}</span>
                  </li>
                </ng-container>
                </ul>
              </div>
            </div>
            <ng-container *ngIf="(filteredParentSeriesPage && filteredParentSeriesPage.length === 0 && insideParentSerisePage)">
              <div class="autosuggestion block" style="top: 62px;">
                <ul>
                  <li>
                    <span class="name">No Results</span>
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>
          <div class="authorName fl100"  *ngIf="pageType == 'SERIES'">
            <div class="">
              <label>Series ID</label>
            </div>
            <div class="Input">
                <tags-creator class="textBox" [editable]="pagePresent" [broadInput]="true" [data]="formData.seriesId" [displayText]="'Add single or multiple series ids here'" [seriesPageIDValidation]="true" (changefn)="formData.seriesId = $event"></tags-creator>
            </div>
          </div>
          <div class="authorName fl100"  *ngIf="pageType == 'SERIES'">
            <div class="">
              <label>SI Tour ID</label>
            </div>
            <div class="Input">
              <input type="text" class="textBox" [(ngModel)]="formData.siTourId"
               placeholder="Add SI Tour ID">
            </div>
          </div>
        <div class="authorName fl100"  *ngIf="pageType !== 'SERIES'">
          <div class="">
            <label>Cover Image</label>
          </div>
          <div class="dataField">
            <div class="uploadimage"><i class="icon-upload"></i>
              <div class="upload-btn-wrapper relative"> <span class="btn">Upload Image</span>
                <input type="file" name="myfile" accept="image/*" (change)="onFileChange($event,'coverImage')"  [disabled]="pagePresent"/>
              </div>
            </div>
            <div class="cover-image">
              <ng-container *ngIf="(pickStoryImageLoad || croppingInProgress) && imageType === 'coverImage' ">
                <div class="imagepreloader">
                  <div class="a" style="--n: 5;">
                    <div class="dot dot1" style="--i: 0;"></div>
                    <div class="dot dot2" style="--i: 1;"></div>
                    <div class="dot dot3" style="--i: 2;"></div>
                    <div class="dot dot4" style="--i: 3;"></div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="coverImageURL && !pickStoryImageLoad && !croppingInProgress">
                <img [src]="coverImageURL" width="173" height="76" /> 
                <!-- {{coverImageName ? coverImageName : ''}} -->
              </ng-container>
            </div>
          </div>
          <div class="authorName fl100" *ngIf="coverImageURL && !pickStoryImageLoad && !croppingInProgress && pageType !== 'BRUNCH'">
            <div class="">
              <label>Image Caption</label>
            </div>
            <div class="Input">
              <input type="text" [(ngModel)]="formData.imageCaption" [readonly]="!adminRole"
                class="textBox" placeholder="Add image caption">
            </div>
          </div>
          <div *ngIf="pageType==='BRUNCH'" class="authorName fl100">
            <div class="">
              <label>Edition Text</label>
            </div>
            <div class="Input">
              <textarea appTextareaAutoresize class="textAreaBox" [(ngModel)]="formData.editionText"
               placeholder="Add Edition Text"></textarea>
            </div>
          </div>
          <ng-container *ngIf="pageType != 'AGENCY' && pageType != 'BRUNCH' && sponsorImageFlag  && pageType !== 'SERIES'">
          <div class="">
          <label>Sponsor Image</label>
          </div>
          <div class="dataField">
            <div class="uploadimage"><i class="icon-upload"></i>
              <div class="upload-btn-wrapper relative"> <span class="btn">Upload Image</span>
                <input type="file" name="myfile" accept="image/*" (change)="onFileChange($event,'sponsorImage')"  [disabled]="pagePresent"/>
              </div>
            </div>
            <div class="cover-image">
              <ng-container *ngIf="(pickStoryImageLoad || croppingInProgress) && imageType === 'sponsorImage' ">
                <div class="imagepreloader">
                  <div class="a" style="--n: 5;">
                    <div class="dot dot1" style="--i: 0;"></div>
                    <div class="dot dot2" style="--i: 1;"></div>
                    <div class="dot dot3" style="--i: 2;"></div>
                    <div class="dot dot4" style="--i: 3;"></div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="sponsorImageURL && !pickStoryImageLoad && !croppingInProgress">
                <img [src]="sponsorImageURL" width="173" height="76" /> 
                {{sponsorImageName ? sponsorImageName : ''}}
              </ng-container>
            </div>
          </div>
          </ng-container>
        </div>
        <ng-container *ngIf="pageType === 'TOPIC'">
          <div class="authorName fl100">
            <div class="">
              <label>Auto-Backlinking Enabled</label>
            </div>
            <label class="switch" tabindex="0">
              <input
                type="checkbox"
                (click)="toggleSwitch('autobacklink')"
                [checked]="formData.toBeAutobacklink"/>
              <span class="slider round"></span>
            </label>
          </div>
          <div class="authorName fl100">
            <div class="">
              <label>Proper Noun</label>
            </div>
            <label class="switch" tabindex="0">
              <input
                type="checkbox"
                (click)="toggleSwitch('propernoun')"
                [checked]="formData.properNoun"/>
              <span class="slider round"></span>
            </label>
          </div>
        </ng-container>
        <ng-container *ngIf="pageType != 'TOPIC' && pageType != 'EXTERNAL' && pageType !='SERIES'">
          <div class="authorName fl100">
            <div class="">
              <label>Page Content</label>
            </div>
            <label class="switch" tabindex="0">
              <input
                type="checkbox"
                (click)="toggleSwitch('pageContent')"
                [checked]="formData.pageContentEnabled"/>
              <span class="slider round"></span>
            </label>
          </div>
        </ng-container>
      </div>
      <div class="fr wid100 right">
        <button type="button" name="cancel" (click)="resetForm()" class="cancel gray ml10">Cancel</button>
        <button type="button" [id]="pageType == 'PRIMARY' || pageType == 'SECTION' || pageType == 'APP_SECTION' ? 'pageSectionCreateButton' : (pageType == 'SUBSECTION' || pageType == 'APP_SUBSECTION') ? 'pageCreateButton' : 'pageTopicCreateButton'" name="add" (click)="savePage()" [disabled]="pagePresent || disableButton || (pageType == 'BRUNCH' && editionDateSelected) || (pageType == 'SERIES'  && !formData.name) || (pageType == 'SERIES' && !formData.siTourId )" class="add blue ml10">Create</button>
      </div>
      <div class="clearBoth"></div>
    </div>
  </div>

  
  <div class="image-cropper" *ngIf="showCropper && imageType === 'coverImage'" [cropperImageUrl]="cropperImageUrl" [pageType]="pageType" (finish)="finishCropping($event,imageType)"
    (cancel)="cancelCropping($event)"></div>

  <div class="image-cropper" *ngIf="showCropper && imageType ==='sponsorImage' " [cropperImageUrl]="cropperImageUrl" (finish)="finishCropping($event,imageType)"
    (cancel)="cancelCropping($event)"></div>
